export const iconFontAwesomeFoodBeverageWineBottle = (
	<i className="fa-solid fa-wine-bottle"></i>
);
